export const PILL_BUTTON_BG = "#9C4FFF";
export const PILL_BUTTON_CLASS_NAME = "pill";
export const GLOBAL_BUTTON_HEIGHT = 40;
export const GLOBAL_BUTTON_ICON_SIZE = 20;
export const PILL_BUTTON_DISABLED_BG = "#FFFFFF";
export const PILL_BUTTON_DISABLED_BORDER = "#D0D5DD";
export const PILL_BUTTON_DISABLED_TEXT = "#98A2B3";

export const withPillButtonClassName = (className = "") =>
  [PILL_BUTTON_CLASS_NAME, className].filter(Boolean).join(" ");

export const pillButtonBaseSx = {
  borderRadius: 999,
  height: GLOBAL_BUTTON_HEIGHT,
  minHeight: GLOBAL_BUTTON_HEIGHT,
  textTransform: "none",
  fontWeight: 400,
  whiteSpace: "nowrap",
};

export const pillButtonInteractiveSx = {
  outline: "none",
  transition:
    "box-shadow 140ms ease, transform 140ms ease, background-color 140ms ease, border-color 140ms ease, color 140ms ease",
  "& .MuiButton-startIcon, & .MuiButton-endIcon": {
    color: "inherit !important",
    "& > *": {
      flexShrink: 0,
    },
  },
  "& .MuiButton-startIcon .MuiSvgIcon-root, & .MuiButton-endIcon .MuiSvgIcon-root": {
    fontSize: `${GLOBAL_BUTTON_ICON_SIZE}px !important`,
  },
  "& .MuiButton-startIcon svg, & .MuiButton-endIcon svg": {
    color: "inherit !important",
    width: `${GLOBAL_BUTTON_ICON_SIZE}px !important`,
    height: `${GLOBAL_BUTTON_ICON_SIZE}px !important`,
    flexShrink: 0,
  },
  "& .MuiButton-startIcon svg [stroke]:not([stroke='none']), & .MuiButton-endIcon svg [stroke]:not([stroke='none'])":
    {
      stroke: "currentColor !important",
    },
  "& .MuiButton-startIcon svg [fill]:not([fill='none']), & .MuiButton-endIcon svg [fill]:not([fill='none'])":
    {
      fill: "currentColor !important",
    },
  "&:hover": {
    outline: "none",
    boxShadow: "0 0 0 1px rgba(255,255,255,0.54) inset",
    "& .MuiButton-startIcon svg, & .MuiButton-endIcon svg": {
      color: `${PILL_BUTTON_BG} !important`,
      fill: "none !important",
      stroke: `${PILL_BUTTON_BG} !important`,
    },
    "& .MuiButton-startIcon svg *, & .MuiButton-endIcon svg *": {
      fill: "none !important",
      stroke: `${PILL_BUTTON_BG} !important`,
      strokeWidth: "1.25px !important",
      strokeLinecap: "round !important",
      strokeLinejoin: "round !important",
    },
  },
  "&:active": {
    outline: "none",
    boxShadow: "0 0 0 1px rgba(255,255,255,0.7) inset",
    transform: "translateY(1px)",
  },
  "&.Mui-disabled": {
    outline: "none",
    color: `${PILL_BUTTON_DISABLED_TEXT} !important`,
    background: `${PILL_BUTTON_DISABLED_BG} !important`,
    backgroundColor: `${PILL_BUTTON_DISABLED_BG} !important`,
    backgroundImage: "none !important",
    borderColor: `${PILL_BUTTON_DISABLED_BORDER} !important`,
    boxShadow: "none !important",
    transform: "none",
    opacity: "1 !important",
  },
};

export const pillButtonFilledSx = {
  ...pillButtonBaseSx,
  color: "#fff",
  background: `${PILL_BUTTON_BG} !important`,
  border: `1px solid ${PILL_BUTTON_BG}`,
  boxShadow: "none",
  "&:hover": {
    background: "#FFFFFF !important",
    color: `${PILL_BUTTON_BG} !important`,
    borderColor: `${PILL_BUTTON_BG} !important`,
    boxShadow: "none !important",
  },
  "&:hover .MuiButton-startIcon, &:hover .MuiButton-endIcon, &:focus-visible .MuiButton-startIcon, &:focus-visible .MuiButton-endIcon": {
    color: `${PILL_BUTTON_BG} !important`,
  },
  "&&&:is(:focus, :focus-visible, .Mui-focusVisible, :visited):not(.Mui-disabled)": {
    color: "#FFFFFF !important",
    background: `${PILL_BUTTON_BG} !important`,
    "& .MuiButton-startIcon, & .MuiButton-endIcon, & svg": { color: "#FFFFFF !important" },
    "& svg [stroke]:not([stroke='none'])": { stroke: "currentColor !important" },
  },
};

export const popupNavigationPillSx = {
  background: "#FFFFFF !important",
  backgroundColor: "#FFFFFF !important",
  color: `${PILL_BUTTON_BG} !important`,
  border: `1px solid ${PILL_BUTTON_BG} !important`,
  borderColor: `${PILL_BUTTON_BG} !important`,
  boxShadow: "none !important",
  "&:hover, &:focus, &:focus-visible, &.Mui-focusVisible, &:active": {
    background: "#FFFFFF !important",
    backgroundColor: "#FFFFFF !important",
    color: `${PILL_BUTTON_BG} !important`,
    border: `1px solid ${PILL_BUTTON_BG} !important`,
    borderColor: `${PILL_BUTTON_BG} !important`,
    boxShadow: "none !important",
  },
  "& .MuiButton-startIcon, & .MuiButton-endIcon, & .MuiButton-startIcon svg, & .MuiButton-endIcon svg": {
    color: `${PILL_BUTTON_BG} !important`,
  },
};

export const quickActionPillButtonSx = {
  ...pillButtonFilledSx,
  height: GLOBAL_BUTTON_HEIGHT,
  minHeight: GLOBAL_BUTTON_HEIGHT,
  px: 3,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1,
  "& .MuiButton-startIcon": {
    marginRight: 0.9,
  },
};

export const compactFilledPillButtonSx = {
  ...pillButtonFilledSx,
  height: GLOBAL_BUTTON_HEIGHT,
  minHeight: GLOBAL_BUTTON_HEIGHT,
  px: 2.2,
  fontSize: 12.5,
  fontWeight: 400,
};

export const toolbarPillButtonSx = {
  height: GLOBAL_BUTTON_HEIGHT,
  minHeight: GLOBAL_BUTTON_HEIGHT,
  px: 2.2,
  fontSize: 12.5,
  fontWeight: 400,
  boxShadow: "none",
};

export const iconPillButtonSx = {
  ...pillButtonFilledSx,
  minWidth: 56,
  height: GLOBAL_BUTTON_HEIGHT,
  minHeight: GLOBAL_BUTTON_HEIGHT,
  px: 1.5,
  borderRadius: 999,
  fontWeight: 400,
  background: `${PILL_BUTTON_BG} !important`,
  color: "#fff",
  border: `1px solid ${PILL_BUTTON_BG}`,
  boxShadow: "none",
  "&:hover": {
    background: "#FFFFFF !important",
    color: `${PILL_BUTTON_BG} !important`,
    borderColor: `${PILL_BUTTON_BG} !important`,
    boxShadow: "none !important",
  },
  "&:hover .MuiButton-startIcon, &:hover .MuiButton-endIcon, &:focus-visible .MuiButton-startIcon, &:focus-visible .MuiButton-endIcon": {
    color: `${PILL_BUTTON_BG} !important`,
  },
};
